import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { trackPageView } from '@/lib/analytics';

// Título/descrição por página. Quando renderizado dentro de PublicLayout,
// sobrescreve o <Helmet> padrão de lá (react-helmet-async prioriza o
// componente montado mais profundo na árvore em caso de conflito).
//
// Também registra o page_view (GA4) com o título final da página. track=false
// enquanto o título ainda não é o definitivo (ex.: evento carregando), pra
// não contar a mesma visita duas vezes.
export function SeoHead({ title, description, track = true }) {
  const { pathname } = useLocation();

  useEffect(() => {
    if (track && title) trackPageView(pathname, title);
  }, [track, title, pathname]);

  return (
    <Helmet>
      {title && <title>{title}</title>}
      {description && <meta name="description" content={description} />}
    </Helmet>
  );
}
